export interface BdMapsStateSelectOptions {
  includeBund: boolean;
  resetOption: boolean;
}

export const BD_MAPS_STATE_SELECT_OPTIONS_DEFAULT: BdMapsStateSelectOptions = {
  includeBund: false,
  resetOption: true
};
